import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';

interface IItem {
  title?: string;
  link?: string;
}

interface BreadcrumbProps {
  items: Array<IItem>;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => (
  <Container className="mt-2 d-flex">
    {items.map((item, index) => (
      <li key={index}>
        {item.link ? (
          <Link to={item.link}>{item?.title}</Link>
        ) : (
          <span>{item.title}</span>
        )}
      </li>
    ))}
  </Container>
);
